<template>
    <div class="c-budget" :class="{'hidden-mobile': hiddenMobile}">
        <div class="budget-title">
            <img src="/img/iconos/icon_budget.svg" alt="icon_budget.svg"> Presupuesto
            <div class="close-icon" @click="hide">
                <i class="fas fa-times"></i>
            </div>
        </div>
        <slot>
            <div class="budget-lines">
                <budget-line v-if="eco" @change-action="changeTipoPlanta" :show-change-btn="!forceTipoPlanta">
                    <template v-slot>
                        Ecológica
                    </template>
                    <template v-slot:icon>
                        <img src="/img/iconos/icon_ecologico.svg" alt="Ecológico">
                    </template>
                    <template v-slot:info>
                        <img v-b-modal.modal-eco src="/img/iconos/icon_info.svg" alt="icon_info.svg" class="icon_info">
                        <modal-block v-cloak title="Ecológico" :href="route('help.details','ecologica')" desing="ecologico" refer="eco">
                            Plantas con certificado ecológico producidas bajo
                            la normativa de producción ecológica UE 834/2007.
                        </modal-block>
                    </template>
                </budget-line>
                <budget-line v-else @change-action="changeTipoPlanta" :show-change-btn="!forceTipoPlanta">
                    <template v-slot>
                        Residuo cero
                    </template>
                    <template v-slot:icon>
                    </template>
                    <template v-slot:info>
                        <img v-b-modal.modal-residuocero src="/img/iconos/icon_info.svg" alt="icon_info.svg" class="icon_info">
                        <modal-block v-cloak title="Residuo Cero" :href="route('help.details','residuo-cero')" desing="residuocero" refer="residuocero">
                            Planta para producción convencional cultivada con productos químicos de bajo impacto.
                        </modal-block>
                    </template>
                </budget-line>
                <budget-line v-if="variety" @change-action="changeVariety">
                    <template v-slot>
                        <div>
                            {{ variety.mote.especie.nombre }}
                            <div style="font-weight: normal">
                                {{ variety.mote.nombre }}
                            </div>
                            <div style="font-weight: normal">
                                {{ variety.nombre }}
                            </div>
                        </div>
                    </template>
                    <template v-slot:icon>
                        <img src="/img/iconos/custom_default.svg" alt="Variedad">
                    </template>
                    <template v-slot:info>
                        <img v-b-modal.modal-variedad src="/img/iconos/icon_info.svg" alt="icon_info.svg" class="icon_info">
                        <modal-block v-cloak title="Variedad" desing="ecologico" refer="variedad">
                            Variedades de plantas hortícolas disponibles
                        </modal-block>
                    </template>
                </budget-line>
                <budget-line v-if="injertada" @change-action="changeTipoInjerto">
                    <template v-slot>
                        Injertada
                    </template>
                    <template v-slot:icon>
                        <img src="/img/iconos/icon_injertada.svg" alt="Injertada">
                    </template>
                    <template v-slot:info>
                        <img v-b-modal.modal-inj src="/img/iconos/icon_info.svg" alt="icon_info.svg" class="icon_info">
                        <modal-block v-cloak title="Especies" :href="route('help.details','injerto')"  desing="ecologico" refer="inj">
                            Tomate, Pimiento, Melón, Sandía, Pepino, Calabacín, Alficoz, Berenjena
                        </modal-block>
                    </template>
                </budget-line>
                <budget-line v-else-if="injertada !== null" @change-action="changeTipoInjerto">
                    <template v-slot>
                        Sin injertar
                    </template>
                    <template v-slot:icon>
                        <img src="/img/iconos/icon_sin_injertar.svg" alt="Injertada">
                    </template>
                    <template v-slot:info>
                        <span></span>
                    </template>
                </budget-line>
                <budget-line v-if="varietyPie" @change-action="changeVarietyPie">
                    <template v-slot>
                        <div>
                            {{ varietyPie.mote.especie.nombre }}
                            <div style="font-weight: normal">
                                {{ varietyPie.mote.nombre }}
                            </div>
                            <div style="font-weight: normal">
                                {{ varietyPie.nombre }}
                            </div>
                        </div>
                    </template>
                    <template v-slot:icon>
                        <img src="/img/iconos/icon_variedad_pie.svg" alt="Variedad pie">
                    </template>
                    <template v-slot:info>
                        <img v-b-modal.modal-variedadpie src="/img/iconos/icon_info.svg" alt="icon_info.svg" class="icon_info">
                        <modal-block v-cloak title="Variedad de pie" desing="ecologico" refer="variedadpie">
                            Variedad de patrón sobre la que se injertará la variedad seleccionada
                        </modal-block>
                    </template>
                </budget-line>
                <budget-line v-if="date" @change-action="changeFecha">
                    <template v-slot>
                        Fecha de entrega <br>
                        <span style="font-weight: normal">{{ dateFormatted }}</span>
                    </template>
                    <template v-slot:icon>
                        <img src="/img/iconos/icon_calendar.svg" alt="Calendario">
                    </template>
                    <template v-slot:info>
                        <img v-b-modal.modal-fechaentrega src="/img/iconos/icon_info.svg" alt="icon_info.svg" class="icon_info">
                        <modal-block v-cloak title="Fecha de entrega" :href="route('help.details','calendario-de-entrega')"  desing="ecologico" refer="fechaentrega">
                            Fecha en la que recibirás la variedad seleccionada.<br>
                            Los envíos salen de Babyplant los martes.
                        </modal-block>
                    </template>
                </budget-line>
                <div class="budget-extra">
                    <b-button variant="outline-secondary" @click="restart" class="go-new-btn" v-b-tooltip.hover title="Borrar el progreso actual y empezar de nuevo">
                        Empezar de nuevo <img src="/img/iconos/icon_back_budget.svg" alt="Empezar de nuevo" style="height: 1em; margin-top: -0.175rem;">
                    </b-button>
                    <b-button variant="outline-secondary" v-show="moreLines" @click="goSummary" class="go-new-btn" v-b-tooltip.hover title="Borrar el progreso actual y va al resumen del presupuesto">
                        Ir al resumen
                    </b-button>
                </div>
            </div>
        </slot>
    </div>
</template>

<script>
    import BudgetLine from "./BudgetLine";

    window.showCustomBudgetMobile = false;

    export default {
        name: "Budget",
        props: {
            budgetData: {
                type: Object,
                required: true
            }
        },
        data() {
            return {
                hiddenMobile: true
            }
        },
        components: {
            BudgetLine
        },
        computed: {
            eco() {
                return this.budgetData.eco_type;
            },
            injertada() {
                return this.budgetData.injerto_type;
            },
            date() {
                return this.budgetData.date;
            },
            dateFormatted() {
                return moment(this.date).format('D [de] MMMM [de] YYYY')
            },
            variety() {
                return this.budgetData.variety;
            },
            varietyPie() {
                return this.budgetData.varietyPie;
            },
            moreLines() {
                return this.budgetData.lines_count > 1;
            },
            forceTipoPlanta() {
                return this.budgetData.force_tipo_planta;
            }
        },
        methods: {
            changeTipoPlanta() {
                window.location = this.route('custom.type-select');
            },
            changeFecha() {
                window.location = this.route('custom.week-select');
            },
            changeVariety() {
                window.location = this.route('custom.variety-select');
            },
            changeTipoInjerto() {
                window.location = this.route('custom.injerto-type-select');
            },
            changeVarietyPie() {
                window.location = this.route('custom.injerto-select');
            },
            show() {
                this.hiddenMobile = false;
                this.$customBudgetShowButton.hide();
            },
            hide() {
                this.hiddenMobile = true;
                this.$customBudgetShowButton.show();
            },
            restart() {
                this.resetLine().then((response) => {
                    window.location = this.route('custom.type-select');
                });
            },
            goSummary() {
                this.resetLine().then((response) => {
                    window.location = this.route('custom.summary');
                });
            },
            resetLine() {
                return axios.post(this.route('custom.reset-line')).catch((e) => {
                    Vue.toasted.show('Ha ocurrido un error', {
                        type: "error",
                        duration: 3000
                    });
                    console.log(e);
                })
            }
        },
        beforeCreate() {
            Vue.prototype.$customBudget = this;
        }
    }
</script>

<style scoped>
    .budget-title {
        background: #333333;
        color: white;
        line-height: 2;
        font-size: 1.5em;
        font-weight: bold;
        position: relative;
    }

    .budget-title img {
        height: 1.3em;
        margin-right: 0.5em;
        margin-top: -0.1em;
    }

    .c-budget .budget-lines {
        padding: 0 10px;
    }

    .c-budget {
        position: fixed;
        top: 12em;
        left: 0;
        z-index: 1040;
        width: 100%;
        height: 100vh;
        background-color: white;
    }

    .c-budget.hidden-mobile {
        display: none;
    }

    .close-icon {
        font-size: 1.5em;
        top: 0;
        right: 0.8rem;
        display: flex;
        align-items: center;
        position: absolute;
        height: 100%;
    }

    .budget-extra {
        padding-top: 0.5rem;
        padding-bottom: 0.5rem;
    }

    .go-new-btn {
        border-radius: 0;
        color: #0b72b8;
        border: 2px solid #0b72b8;
        font-weight: bold;
    }

    .go-new-btn:hover {
        background-color: #c9c9c9;
    }

    @media (min-width: 992px) {
        .c-budget {
            position: relative;
            top: auto;
            left: auto;
            z-index: auto;
            width: auto;
            height: auto;
        }

        .c-budget.hidden-mobile {
            display: block;
        }

        .close-icon {
            display: none;
        }
    }


</style>

